import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL } from "@/lib/seo-schemas";

const MentionsLegales = () => {
  const breadcrumbItems = [
    { label: "Accueil", href: "/" },
    { label: "Mentions légales", href: "/mentions-legales" },
  ];

  return (
    <>
      <Helmet>
        <title>Mentions Légales | {SITE_NAME}</title>
        <meta name="description" content={`Mentions légales du site ${SITE_NAME}. Informations sur l'éditeur, l'hébergeur et les conditions d'utilisation.`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${SITE_URL}/mentions-legales`} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <Breadcrumbs items={breadcrumbItems} />

        <main className="max-w-4xl mx-auto px-4 py-16">
          <h1 className="text-3xl md:text-4xl font-black text-foreground mb-8">Mentions Légales</h1>
          <p className="text-sm text-muted-foreground mb-8">Dernière mise à jour : 21 février 2026</p>

          <div className="space-y-8 text-muted-foreground leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">1. Éditeur du site</h2>
              <p>Nom : {SITE_NAME}</p>
              <p>Site web : <a href={SITE_URL} className="text-primary hover:underline">{SITE_URL}</a></p>
              <p>Email : <a href="mailto:contact@roidustreaming.fr" className="text-primary hover:underline">contact@roidustreaming.fr</a></p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">2. Hébergement</h2>
              <p>Le site est hébergé par Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">3. Propriété intellectuelle</h2>
              <p>L'ensemble du contenu du site {SITE_NAME} (textes, graphismes, logos, images) est protégé par le droit de la propriété intellectuelle. Toute reproduction non autorisée est interdite.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">4. Données personnelles</h2>
              <p>
                Pour en savoir plus sur la collecte et le traitement de vos données personnelles, consultez notre{" "}
                <a href="/politique-de-confidentialite" className="text-primary hover:underline">Politique de Confidentialité</a>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">5. Cookies</h2>
              <p>Le site utilise des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie publicitaire ou de traçage n'est utilisé.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">6. Loi applicable</h2>
              <p>Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default MentionsLegales;
